module.exports = __webpack_public_path__ + "img/看板.c7468984.svg";